import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "game-layout" }
const _hoisted_2 = {
  key: 2,
  class: "day-view"
}
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]

import { computed } from 'vue';
import { useGameStore } from '@/stores/gameStore';
import type { PlayerPublic } from '@/types/game';

import MyRolePanel from './MyRolePanel.vue';
import NightActionsPanel from './NightActionsPanel.vue';
import HostDisplay from './HostDisplay.vue';
import PlayerGrid from './PlayerGrid.vue';
import PlayerCard from './PlayerCard.vue';
import TimerBar from './TimerBar.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'GameLayout',
  props: {
    selectedPlayerName: {}
  },
  emits: ['playerSelect'],
  setup(__props: any) {

const props = __props;


const gameStore = useGameStore();

const isDiscussionPhase = computed(() => {
    const phase = gameStore.room?.phase;
    return phase === 'day' || phase === 'introduction_day';
});

const isVotingPhase = computed(() => gameStore.isVotingPhase);

const hostMessage = computed(() => {
    const activeNarration = gameStore.room?.active_narration;
    if (activeNarration) {
        const phase = gameStore.room?.phase;
        if (phase === 'joke_voting' || phase === 'voting') {
            return activeNarration.summary ?? activeNarration.narration ?? '';
        }
        return activeNarration.narration ?? activeNarration.summary ?? '';
    }

    if ((gameStore.room?.last_events ?? []).length > 0) {
        return 'Ведущий подводит итоги...';
    }

    const phase = gameStore.room?.phase;
    switch (phase) {
        case 'introduction_day':
        case 'day':
            return "Идет обсуждение. Выскажите свои подозрения.";
        case 'joke_voting':
            return "Шуточное голосование. Выберите самого подозрительного игрока.";
        case 'voting':
            return "Голосование за казнь. Выберите, кого вы считаете мафией.";
        default:
            return '';
    }
});

const isPlayerSelectable = (player: PlayerPublic) => {
    if (!player.is_alive || gameStore.myPlayerHasActed) return false;
    return isVotingPhase.value;
};

const voteButtonText = computed(() => {
    if (gameStore.myPlayerHasActed) return 'Ожидаем других...';
    if (props.selectedPlayerName) {
        const actionText = gameStore.room?.phase === 'joke_voting' ? 'Голосовать за' : 'Голосовать за казнь';
        return `${actionText} "${props.selectedPlayerName}"`;
    }
    return 'Выберите игрока';
});

const readyForVote = () => gameStore.performAction('ready_for_vote', {});
const submitVote = () => {
    if (!props.selectedPlayerName) return;
    gameStore.performAction('vote', { target_name: props.selectedPlayerName });
    gameStore.confirmTeamTarget(props.selectedPlayerName);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MyRolePanel),
    (_unref(gameStore).room?.phase_time_left && _unref(gameStore).room.phase_duration)
      ? (_openBlock(), _createBlock(TimerBar, {
          key: 0,
          "initial-time-left": _unref(gameStore).room.phase_time_left,
          "total-duration": _unref(gameStore).room.phase_duration
        }, null, 8, ["initial-time-left", "total-duration"]))
      : _createCommentVNode("", true),
    (_unref(gameStore).isNightActionPhase)
      ? (_openBlock(), _createBlock(NightActionsPanel, {
          key: 1,
          "selected-player-name": _ctx.selectedPlayerName,
          onPlayerSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('playerSelect', $event)))
        }, null, 8, ["selected-player-name"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(HostDisplay, { message: hostMessage.value }, null, 8, ["message"]),
          _createVNode(PlayerGrid, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gameStore).room?.players, (player) => {
                return (_openBlock(), _createBlock(PlayerCard, {
                  key: player.name,
                  player: player,
                  "is-selectable": isPlayerSelectable(player),
                  "is-selected": player.name === _ctx.selectedPlayerName,
                  onClick: ($event: any) => (isPlayerSelectable(player) && _ctx.$emit('playerSelect', player.name))
                }, null, 8, ["player", "is-selectable", "is-selected", "onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ])),
    _createElementVNode("div", _hoisted_3, [
      (isDiscussionPhase.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: readyForVote,
            disabled: _unref(gameStore).myPlayerHasActed,
            class: "btn"
          }, _toDisplayString(_unref(gameStore).myPlayerHasActed ? 'Ожидаем других...' : 'Готов к голосованию'), 9, _hoisted_4))
        : _createCommentVNode("", true),
      (isVotingPhase.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: submitVote,
            disabled: !_ctx.selectedPlayerName || _unref(gameStore).myPlayerHasActed,
            class: "btn"
          }, _toDisplayString(voteButtonText.value), 9, _hoisted_5))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})